// extracted by mini-css-extract-plugin
export var tosLink = "_bm-0";